"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlRulesClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class UrlRulesClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.baseUrl = '/v1/projects/';
    }
    getRules(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/url-rules`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    createRule(urlRule) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${urlRule.projectId}/url-rules`;
            const response = yield this.httpPost(url, urlRule);
            return response.payload;
        });
    }
    updateRule(urlRule) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${urlRule.projectId}/url-rules`;
            const response = yield this.httpPut(url, urlRule);
            return response.payload;
        });
    }
    deleteRule(projectId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/url-rules/${id}`;
            const response = yield this.httpDelete(url);
            return response.payload;
        });
    }
    switchRules(projectId, urlRule) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/url-rules/switch-rules`;
            const response = yield this.httpPost(url, urlRule);
            return response.payload;
        });
    }
}
exports.UrlRulesClient = UrlRulesClient;
//# sourceMappingURL=url-rules.client.js.map